/**
 * Rollenbeheer: menu-onderdelen en acties. Houd gelijk met Backendsrv/config/permissions.js.
 * Permissies hebben de vorm "<menuKey>:<actie>", bijv. "payments:update".
 */
export const MENU_PERMISSION_ITEMS = [
  { key: 'studies', label: 'Programmastructuur' },
  { key: 'study-registrations', label: 'Studie-inschrijvingen' },
  { key: 'course-assignments', label: 'Vak toewijzen' },
  { key: 'homework', label: 'Huiswerk' },
  { key: 'module-materials', label: 'Module materialen' },
  { key: 'module-evaluations', label: 'Module evaluaties' },
  { key: 'exam-component-uploads', label: 'Examen uploads' },
  { key: 'calendar', label: 'Kalender' },
  { key: 'payments', label: 'Betalingen' },
  { key: 'users', label: 'Gebruikers' },
  { key: 'cohorts', label: 'Cohorten' },
  { key: 'departments', label: 'Afdelingen' },
  { key: 'content', label: 'Website content' },
  { key: 'notifications', label: 'Notificaties' },
  { key: 'student-declarations', label: 'Verklaringen aanvragen' },
  { key: 'administrative-declarations', label: 'Verklaringen administratie' },
  { key: 'report-payments', label: 'Betalingen rapport' },
  { key: 'grades-entry', label: 'Cijfers invullen' },
  { key: 'annual-grade-list', label: 'Jaarlijkse cijferlijst' }
];

export const PERMISSION_ACTIONS = [
  { key: 'create', label: 'Aanmaken' },
  { key: 'read', label: 'Lezen' },
  { key: 'update', label: 'Wijzigen' },
  { key: 'delete', label: 'Verwijderen' }
];

const MENU_KEYS = new Set(MENU_PERMISSION_ITEMS.map((item) => item.key));

// Menu-sleutel bij een pad, bijv. "/admin/payments/123" -> "payments".
export const menuKeyForPath = (pathname = '') => {
  const segment = String(pathname).replace(/^\/admin\/?/, '').split('/')[0];
  return MENU_KEYS.has(segment) ? segment : null;
};

/**
 * Admin mag altijd alles. Managers/instructeurs zonder toegangsrol houden het standaardgedrag van hun rol.
 * Met een toegangsrol bepalen alleen de toegewezen permissies wat mag.
 */
export const hasPermission = (user, menuKey, action = 'read') => {
  if (!user) return false;
  if (user.role === 'admin') return true;
  if (!menuKey || !MENU_KEYS.has(menuKey)) return true;
  if (!user.hasAccessRole) return true;
  return (user.permissions || []).includes(`${menuKey}:${action}`);
};
